exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".done{width:344px;margin:auto;text-align:center;margin-top:-40px;margin-bottom:20px}.done img{width:80%}.done h3{color:#265390;font-size:28px;margin-top:0}.done span{color:#ababab;font-size:16px}@media (min-width: 1367px){.done{margin-top:40px}.done img{width:100%}}@media (max-width: 1366px){.done h3{font-size:24px}}@media (max-width: 767px){.done{left:0;top:158px}}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/things/onboard/done.component.scss
// module id = 1388
// module chunks = 0